import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const CutOutRibKnitBlack = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.tops.CutOutRibKnitBlack.itemName}
      name={AW23.tops.CutOutRibKnitBlack.itemName}
      price={AW23.tops.CutOutRibKnitBlack.itemPrice}
      fabric={AW23.tops.CutOutRibKnitBlack.itemFabric}
      src={AW23.tops.CutOutRibKnitBlack.sizeChart}
      divId={AW23.tops.CutOutRibKnitBlack.shopifyDivId}
      mainId={AW23.tops.CutOutRibKnitBlack.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.tops.CutOutRibKnitBlack.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.tops.CutOutRibKnitBlack.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default CutOutRibKnitBlack;
